var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpLeftInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70903 4.66499C8.45519 4.41115 8.04364 4.41115 7.78979 4.66499L4.03979 8.41499C3.78595 8.66883 3.78595 9.08039 4.03979 9.33423L7.78979 13.0842C8.04364 13.3381 8.45519 13.3381 8.70903 13.0842C8.96287 12.8304 8.96287 12.4188 8.70903 12.165L5.41865 8.87461L8.70903 5.58423C8.96287 5.33039 8.96287 4.91883 8.70903 4.66499Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1244 9.52656C16.1123 9.52656 17.0598 9.91902 17.7584 10.6176C18.457 11.3162 18.8494 12.2636 18.8494 13.2516C18.8494 14.2395 18.457 15.187 17.7584 15.8855C17.0598 16.5841 16.1123 16.9766 15.1244 16.9766H8.24941C7.89043 16.9766 7.59941 17.2676 7.59941 17.6266C7.59941 17.9855 7.89043 18.2766 8.24941 18.2766H15.1244C16.4571 18.2766 17.7353 17.7471 18.6776 16.8048C19.62 15.8624 20.1494 14.5843 20.1494 13.2516C20.1494 11.9188 19.62 10.6407 18.6776 9.69835C17.7353 8.75598 16.4571 8.22656 15.1244 8.22656H4.49941C4.14043 8.22656 3.84941 8.51758 3.84941 8.87656C3.84941 9.23555 4.14043 9.52656 4.49941 9.52656H15.1244Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLeftInactive);
export default __webpack_public_path__ + "static/media/arrow-up-left-inactive.e81790ad7661c9eafbabe87591134438.svg";
export { ForwardRef as ReactComponent };